<nav class="navbar navbar-expand navbar-dark tw-bg-black-3 osahan-nav-top p-1 tw-w-full tw-z-20 tw-pb-32" [class.tw-hidden]="hideNavbar">

  <div class="tw-flex tw-w-full tw-items-center tw-gap-x-1 md:tw-px-3 tw-px-1">

    <!-- <div class="tw-p-2 tw-rounded tw-transition sm:tw-hidden tw-block" (click)="toggleSidenav()"
      aria-label="Toggle Sidenav">
      <span class="material-icons tw-text-gray-400 hover:tw-text-gray-200 tw-text-2xl">menu</span>
    </div> -->

    <a class="tw-mx-2 md:tw-mx-3 tw-shrink-0 tw-flex tw-items-center tw-gap-2 tw-no-underline" routerLink="/" aria-label="Safety Knights home">
      <img src="logo/safety-knights-logo-light.png" class="tw-h-10.5" alt="" width="38" height="42">
      <span class="tw-hidden md:tw-block tw-text-white tw-font-bold tw-uppercase tw-tracking-wide tw-text-[13px] tw-leading-[1.05]">Safety<br />Knights</span>
    </a>

    <ul class="navbar-nav mx-auto tw-flex tw-items-center tw-whitespace-nowrap tw-gap-0.5">
      <!-- lg and up: the mockup's six groups, each a dropdown -->
      <li class="nav-item md:tw-block tw-hidden tw-cursor-pointer">
        <a class="nav-link tw-rounded-full tw-bg-gradient-to-r tw-from-orange-500 tw-to-orange-600 hover:tw-from-orange-600 hover:tw-to-orange-700 tw-text-white hover:tw-text-white tw-font-semibold tw-shadow-sm tw-transition-all"
        style="padding-top: 2px; padding-bottom: 2px; padding-left: 16px; padding-right: 16px; line-height: 1.2;"
        routerLink="/previousSummitStreams" matTooltip="People's Summit" matTooltipPosition="below"
        matTooltipShowDelay="500"><span class="d-none d-lg-inline">Rewatch People's Summit Stream</span></a>
      </li>
      @for (group of navGroups; track group.label) {
      <li class="nav-item lg:tw-block tw-hidden">
        <a class="nav-link tw-flex tw-items-center tw-gap-1.5 tw-px-2.5" [matMenuTriggerFor]="groupMenu" role="button" aria-haspopup="true" aria-expanded="false">
          <span>{{ group.label }}</span><i class="fa-solid fa-chevron-down tw-text-[10px] tw-opacity-70" aria-hidden="true"></i>
        </a>
        <mat-menu #groupMenu="matMenu" xPosition="after" yPosition="below" class="tw-shadow-md m-0 dark:tw-bg-navy tw-bg-white tw-border dark:tw-border-navy tw-border-white border-0 tw-rounded-lg tw-px-2 tw-py-1 tw-min-w-56 dark:tw-text-white tw-text-navy">
          <div (click)="$event.stopPropagation()" class="tw-px-1 tw-py-1">
            @for (item of group.items; track item.label) {
              @if (!item.authOnly || (authService.user$ | async)) {
                @if (item.action === 'jobs') {
                <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white tw-cursor-pointer" (click)="handleJobsClick()">{{ item.label }}</a>
                } @else {
                <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white" [class.tw-text-orange-500]="item.highlight" [class.tw-font-semibold]="item.highlight"
                  [routerLink]="item.link" [queryParams]="item.queryParams || null">{{ item.label }}</a>
                }
              }
            }
          </div>
        </mat-menu>
      </li>
      }

      <!-- below lg: everything in one menu, grouped -->
      <li class="nav-item lg:tw-hidden">
        <a class="nav-link tw-flex tw-items-center tw-gap-1.5" [matMenuTriggerFor]="compactMenu" role="button" aria-haspopup="true" aria-expanded="false">
          <span>Menu</span><i class="fa-solid fa-chevron-down tw-text-[10px] tw-opacity-70" aria-hidden="true"></i>
        </a>
        <mat-menu #compactMenu="matMenu" xPosition="after" yPosition="below" class="tw-shadow-md m-0 dark:tw-bg-navy tw-bg-white tw-border dark:tw-border-navy tw-border-white border-0 tw-rounded-lg tw-px-2 tw-py-1 tw-min-w-56 dark:tw-text-white tw-text-navy">
          <div class="tw-max-h-[75vh] tw-overflow-y-auto tw-px-1 tw-py-1">
            <a class="tw-flex tw-items-center tw-gap-3 tw-mx-3 tw-my-1 tw-px-4 tw-py-2 tw-rounded-full tw-bg-gradient-to-r tw-from-orange-500 tw-to-orange-600 hover:tw-from-orange-600 hover:tw-to-orange-700 tw-text-white tw-text-sm tw-font-semibold tw-shadow-md tw-transition-all md:tw-hidden"
            routerLink="/previousSummitStreams">
            <div
              class="tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-white/20 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
              <ng-icon name="heroTrophy" class="tw-text-white tw-text-title-sm"></ng-icon>
            </div>
            Rewatch People's Summit Stream
          </a>
            @for (group of navGroups; track group.label) {
            <div class="tw-px-3 tw-pt-3 tw-pb-1 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-wide tw-opacity-60">{{ group.label }}</div>
            @for (item of group.items; track item.label) {
              @if (!item.authOnly || (authService.user$ | async)) {
                @if (item.action === 'jobs') {
                <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white tw-cursor-pointer" (click)="handleJobsClick()">{{ item.label }}</a>
                } @else {
                <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white" [class.tw-text-orange-500]="item.highlight" [class.tw-font-semibold]="item.highlight"
                  [routerLink]="item.link" [queryParams]="item.queryParams || null">{{ item.label }}</a>
                }
              }
            }
            }
          </div>
        </mat-menu>
      </li>

      <!-- Summit CTA stays in the bar while the summit is live -->
      <!-- <li class="nav-item md:tw-block tw-hidden tw-cursor-pointer tw-ml-1">
        <a class="nav-link tw-rounded-full tw-bg-gradient-to-r tw-from-orange-500 tw-to-orange-600 hover:tw-from-orange-600 hover:tw-to-orange-700 tw-text-white hover:tw-text-white tw-font-semibold tw-shadow-sm tw-transition-all tw-whitespace-nowrap"
        style="padding-top: 2px; padding-bottom: 2px; padding-left: 14px; padding-right: 14px; line-height: 1.2;"
        routerLink="/peoples_summit" matTooltip="People's Summit" matTooltipPosition="below"
        matTooltipShowDelay="500"><span class="tw-hidden 2xl:tw-inline">Attend People's Summit</span><span class="2xl:tw-hidden">Summit</span></a>
      </li> -->
    </ul>

    <ul class="navbar-nav ml-auto d-flex align-items-center tw-shrink-0 tw-whitespace-nowrap">

      <!-- Search: icon that opens the search field (same menu the phone layout used) -->
      <li class="nav-item dropdown no-arrow" matTooltip="Search" matTooltipPosition="below" matTooltipShowDelay="500">
        <a class="nav-link" [matMenuTriggerFor]="searchMenu" role="button" aria-haspopup="true" aria-expanded="false" aria-label="Search">
          <i class="fa-solid fa-magnifying-glass tw-text-lg"></i>
        </a>
        <mat-menu #searchMenu="matMenu" xPosition="before" class="tw-w-full tw-shadow-md m-0 dark:tw-bg-navy tw-bg-white tw-border
                 dark:tw-border-navy tw-border-white tw-rounded-lg tw-px-2
                 tw-min-w-[100vw] dark:tw-text-white tw-text-navy">
          <div (click)="$event.stopPropagation()">
            <div class="form-inline mr-auto navbar-search">
              <div class="input-group tw-w-[97vw]">
                <input type="text" class="form-control border-0 tw-py-0 tw-h-9 shadow-none dark:tw-bg-navy tw-bg-white"
                  placeholder="Search people, jobs & more..." aria-label="Search" aria-describedby="basic-addon2"
                  [formControl]="searchControl" (keydown.enter)="onSearch()" />
                <div class="input-group-append">
                  <div class="btn" type="button" (click)="onSearch()">
                    <i class="fa-solid fa-magnifying-glass tw-text-navy dark:tw-text-white"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </li>

      


     

      <!-- <li class="nav-item md:tw-block tw-hidden tw-cursor-pointer">
        <a class="nav-link" (click)="handleJobsClick()" matTooltip="Jobs" matTooltipPosition="below"
          matTooltipShowDelay="500"><span class="d-none d-lg-inline">Jobs</span></a>
      </li>

      <li class="nav-item md:tw-block tw-hidden tw-cursor-pointer">
        <a class="nav-link" routerLink="/podcasts" matTooltip="Podcasts" matTooltipPosition="below"
          matTooltipShowDelay="500"><span class="d-none d-lg-inline">Podcasts</span></a>
      </li>

      <li class="nav-item md:tw-block tw-hidden tw-cursor-pointer">
        <a class="nav-link" routerLink="/content" matTooltip="Content" matTooltipPosition="below"
          matTooltipShowDelay="500"><span class="d-none d-lg-inline">Content</span></a>
      </li>

      <li class="nav-item md:tw-block tw-hidden tw-cursor-pointer">
        <a class="nav-link" routerLink="/quizzes" matTooltip="Content" matTooltipPosition="below"
          matTooltipShowDelay="500"><span class="d-none d-lg-inline">Quizzes</span></a>
      </li>

      <li class="nav-item md:tw-block tw-hidden tw-cursor-pointer">
        <a class="nav-link" routerLink="/referral" matTooltip="Content" matTooltipPosition="below"
          matTooltipShowDelay="500"><span class="d-none d-lg-inline">Referrals</span></a>
      </li> -->

      <!-- <li class="nav-item mr-2" matTooltip="More" matTooltipPosition="below">
        <a class="nav-link pr-0" [matMenuTriggerFor]="menu" role="button" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false"><span class="d-inline tw-mr-2">More</span>
          <i class="fa-solid fa-chevron-down tw-mt-0.5"></i>
        </a>
        <mat-menu #menu="matMenu" xPosition="before" yPosition="below"
          class="tw-w-full tw-shadow-md m-0 dark:tw-bg-navy tw-bg-white tw-border dark:tw-border-navy tw-border-white border-0 tw-rounded-lg tw-px-2 tw-min-w-48 dark:tw-text-white tw-text-navy"> -->
          <!-- <a class="dropdown-item tw-text-sm hover:tw-text-white tw-flex md:tw-hidden bg-gradient dark:tw-text-white"
            [routerLink]="['/intern']">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <img src="../../../assets/img/menu-icon/premium-icon.png" width="23" height="23" alt="">
            </div>
            Get Premium
          </a> -->
          <!-- <a class="tw-flex tw-items-center tw-gap-3 tw-mx-3 tw-my-1 tw-px-4 tw-py-2 tw-rounded-full tw-bg-gradient-to-r tw-from-orange-500 tw-to-orange-600 hover:tw-from-orange-600 hover:tw-to-orange-700 tw-text-white tw-text-sm tw-font-semibold tw-shadow-md tw-transition-all md:tw-hidden"
            routerLink="/previousSummitStreams">
            <div
              class="tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-white/20 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
              <ng-icon name="heroTrophy" class="tw-text-white tw-text-title-sm"></ng-icon>
            </div>
            Rewatch People's Summit Stream
          </a> -->
          <!-- <a class="dropdown-item tw-text-sm hover:tw-text-white tw-flex md:tw-hidden dark:tw-text-white"
            routerLink="/jobs">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <ng-icon name="heroBriefcase" class="tw-text-white tw-text-title-sm"></ng-icon>
            </div>
            Jobs
          </a>
          <a class="dropdown-item tw-text-sm hover:tw-text-white tw-flex md:tw-hidden dark:tw-text-white"
            routerLink="/podcasts">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <ng-icon name="heroMicrophone" class="tw-text-white tw-text-title-sm"></ng-icon>
            </div>
            Podcasts
          </a>

          

          <a class="dropdown-item tw-text-sm hover:tw-text-white tw-flex md:tw-hidden dark:tw-text-white"
            routerLink="/content">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-text-title-sm tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <ng-icon name="heroSquares2x2" class="tw-text-white"></ng-icon>
            </div>
            Content
          </a>

          <a class="dropdown-item tw-text-sm hover:tw-text-white tw-flex md:tw-hidden dark:tw-text-white"
            routerLink="/quizzes">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <ng-icon name="heroMicrophone" class="tw-text-white tw-text-title-sm"></ng-icon>
            </div>
            Quizzes
          </a>

          <a class="dropdown-item tw-text-sm hover:tw-text-white tw-flex md:tw-hidden dark:tw-text-white"
            routerLink="/referral">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <ng-icon name="heroUserPlus" class="tw-text-white tw-text-title-sm"></ng-icon>
            </div>
            Referrals
          </a> -->

          <!-- @for (nav of navData; track $index) {
          <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white" [routerLink]="'/'+nav.routeLink"
            *ngIf="nav.visible">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <ng-icon [name]="nav.icon" size="20" class="tw-text-white" />
            </div>
            {{nav.label}}
          </a>
          }

        </mat-menu>
      </li> -->


      <li class="nav-item xl:tw-block tw-hidden" matTooltip="Partner With Us" matTooltipPosition="below" matTooltipShowDelay="500">
        <a class="nav-link tw-rounded-full tw-border tw-border-orange-500/70 tw-text-orange-400 hover:tw-bg-orange-500 hover:tw-text-white tw-px-4 tw-mx-1 tw-transition-colors tw-text-sm" routerLink="/partners"><i class="fa-regular fa-handshake tw-mr-2" aria-hidden="true"></i>Partner With Us</a>
      </li>

      @if (authService.user$ | async; as user) {
      <!-- <li class="nav-item dropdown no-arrow mx-1 osahan-list-dropdown">
      <a routerLink="/messages" class="nav-link dropdown-toggle position-relative" role="button" aria-haspopup="true"
        aria-expanded="false">
        <ng-icon name="heroChatBubbleOvalLeft" size="20" />
        
        <span *ngIf="totalUnreadMessageCount > 0" 
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
          {{ totalUnreadMessageCount > 99 ? '99+' : totalUnreadMessageCount }}
          <span class="visually-hidden">unread messages</span>
        </span>
      </a>
    </li> -->

      <li class="nav-item dropdown no-arrow mx-1 osahan-list-dropdown" matTooltip="Notifications"
        matTooltipPosition="below">
        <a class="nav-link dropdown-toggle" [matMenuTriggerFor]="notificationMenu" role="button" aria-haspopup="true"
          aria-expanded="false">
          <ng-icon name="heroBellAlert" size="20" />
          <span class="badge badge-info badge-counter tw-bg-red-500 tw-text-white tw-font-medium"
            *ngIf="count > 0">{{count}}</span>
        </a>
        <mat-menu #notificationMenu="matMenu" xPosition="before" class="tw-w-full tw-shadow-xl m-0 dark:tw-bg-slate-800/95 tw-bg-white/95
                           backdrop-blur-lg tw-backdrop-filter tw-border-0 tw-rounded-xl 
                           dark:tw-text-slate-100 tw-text-slate-800 md:tw-min-w-100 tw-min-w-screen">
          <div class="tw-rounded-xl tw-overflow-hidden">

            <!-- Header -->
            <div class="tw-p-4 tw-flex tw-justify-between tw-items-center tw-bg-white/50 dark:tw-bg-slate-800/50">
              <div class="tw-flex tw-items-center tw-gap-3">
                <h3
                  class="tw-text-xl tw-font-bold tw-m-0 tw-bg-gradient-to-r tw-from-blue-600 tw-to-purple-600 tw-bg-clip-text tw-text-transparent">
                  Notifications
                </h3>
                <div *ngIf="notificationCount > 0" class="tw-badge tw-badge-sm tw-badge-primary">
                  {{ notificationCount }}
                </div>
              </div>
              <button
                class="tw-p-1 tw-rounded-full hover:tw-bg-slate-100/50 dark:hover:tw-bg-slate-700/50 tw-transition-colors">
                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <!-- Notification List -->
            <div class="tw-max-h-96 tw-w-full tw-overflow-y-auto tw-overflow-x-hidden tw-px-2 tw-py-1 notification-menu"
              (scroll)="handleScroll($event)">

              @for (notify of notifications; track notify._id) {
              <div class="tw-group tw-relative tw-p-3 tw-m-2 tw-rounded-xl tw-transition-all tw-cursor-pointer
                           hover:tw-bg-slate-100/50 dark:hover:tw-bg-slate-700/50" [class.unread]="notify.unread"
                (click)="handleNotificationClick(notify)">

                <!-- Delete Button -->
                <button (click)="deleteNotification(notify._id); $event.stopPropagation()" class="tw-absolute tw-right-3 tw-top-1/2 tw-p-1.5 tw-rounded-full tw-opacity-0 group-hover:tw-opacity-100
                                 tw-bg-white/80 dark:tw-bg-slate-700/80 hover:tw-bg-slate-200/80 dark:hover:tw-bg-slate-600/80
                                 tw-backdrop-blur-sm tw-shadow-sm tw-transition-all tw-transform -tw-translate-y-1/2">
                  <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>

                <!-- Notification Content -->
                <div class="tw-flex tw-gap-3 tw-items-start">

                  <!-- Enhanced Icon Container -->
                  <div class="tw-relative tw-mt-1">
                    <div class="tw-w-10 tw-h-10 tw-rounded-lg tw-flex tw-items-center tw-justify-center"
                      [ngClass]="getNotificationIconBackground(notify.notificationType)">
                      <ng-container [ngSwitch]="getNotificationIcon(notify)">
                        <app-user-avatar *ngSwitchCase="'user-plus'" [pictureKey]="notify.profilePictureKey"
                          [pictureTransform]="notify.pictureTransform" [pictureID]="notify._id"
                          imgClass="tw-w-10 tw-h-10 tw-object-cover">
                        </app-user-avatar>
                        <app-user-avatar *ngSwitchCase="'user-check'" [pictureKey]="notify.profilePictureKey"
                          [pictureTransform]="notify.pictureTransform" [pictureID]="notify._id"
                          imgClass="tw-w-10 tw-h-10 tw-object-cover">
                        </app-user-avatar>
                        <app-user-avatar *ngSwitchCase="'user-minus'" [pictureKey]="notify.profilePictureKey"
                          [pictureTransform]="notify.pictureTransform" [pictureID]="notify._id"
                          imgClass="tw-w-10 tw-h-10 tw-object-cover">
                        </app-user-avatar>

                        <!-- Existing Icons -->
                        <svg *ngSwitchCase="'email'" class="tw-w-5 tw-h-5 tw-text-blue-600 dark:tw-text-blue-400"
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>

                        <svg *ngSwitchCase="'message'" class="tw-w-5 tw-h-5 tw-text-blue-600 dark:tw-text-blue-400"
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                        </svg>

                        <svg *ngSwitchCase="'answer'" class="tw-w-5 tw-h-5 tw-text-purple-600 dark:tw-text-purple-400"
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                        </svg>

                        <svg *ngSwitchCase="'user'" class="tw-w-5 tw-h-5 tw-text-green-600 dark:tw-text-green-400"
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>

                        <svg *ngSwitchCase="'warning'" class="tw-w-5 tw-h-5 tw-text-red-600 dark:tw-text-red-400"
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>

                        <svg *ngSwitchCase="'like'" class="tw-w-5 tw-h-5 tw-text-pink-600 dark:tw-text-pink-400"
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>

                        <svg *ngSwitchCase="'vote'" class="tw-w-5 tw-h-5 tw-text-indigo-600 dark:tw-text-indigo-400"
                          fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                        </svg>
                      </ng-container>
                    </div>

                    @if (notify.unread) {
                    <div
                      class="tw-absolute -tw-right-1 -tw-top-1 tw-w-3 tw-h-3 tw-rounded-full tw-bg-red-500 tw-ring-2 tw-ring-white dark:tw-ring-slate-800">
                    </div>
                    }
                  </div>

                  <div class="tw-flex-1 tw-overflow-x-hidden">

                    <div class="tw-flex tw-items-center tw-justify-between tw-mb-1.5">
                      <p class="tw-text-sm tw-text-slate-700 dark:tw-text-slate-300 tw-mb-0 tw-line-clamp-2">
                        <span class="tw-text-sm tw-font-medium tw-text-slate-700 dark:tw-text-slate-300">
                          {{ notify?.name }}
                        </span> {{ notify.text }}
                      </p>
                      <span class="tw-text-xs tw-text-slate-500 tw-capitalize tw-ml-2 tw-flex-shrink-0">
                        {{ notify.timeStamp | timeAgo }}
                      </span>
                    </div>

                    @if (notify?.message && isConnectionRequest(notify.notificationType)) {
                    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
                      <span class="tw-text-sm tw-font-normal tw-text-slate-700/80 dark:tw-text-slate-300/80">
                        "{{ notify?.message }}"
                      </span>
                    </div>
                    }



                    <!-- Action Buttons for Connection Requests -->
                    <!-- @if (notify.notificationType === 'connection-request' && notify.unread) {
                    <div class="tw-flex tw-gap-2 tw-mt-2">
                      <button class="tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-bg-green-100 tw-text-green-700 
                                       hover:tw-bg-green-200 dark:tw-bg-green-900/30 dark:tw-text-green-400 
                                       dark:hover:tw-bg-green-900/50 tw-rounded-lg tw-transition-colors tw-border-0">
                        <svg class="tw-w-4 tw-h-4 tw-inline tw-mr-1" fill="none" stroke="currentColor"
                          viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13l4 4L19 7" />
                        </svg>
                        Accept
                      </button>
                      <button class="tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-bg-red-100 tw-text-red-700 
                                       hover:tw-bg-red-200 dark:tw-bg-red-900/30 dark:tw-text-red-400 
                                       dark:hover:tw-bg-red-900/50 tw-rounded-lg tw-transition-colors tw-border-0">
                        <svg class="tw-w-4 tw-h-4 tw-inline tw-mr-1" fill="none" stroke="currentColor"
                          viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        Decline
                      </button>
                    </div>
                    } -->

                    <!-- Connection Status for Accepted/Rejected -->
                    @if (notify.notificationType === 'connection-accepted') {
                    <div class="tw-flex tw-items-center tw-gap-1 tw-mt-2">
                      <svg class="tw-w-4 tw-h-4 tw-text-green-600" fill="none" stroke="currentColor"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span class="tw-text-xs tw-text-green-600 tw-font-medium">Connection Accepted</span>
                    </div>
                    }

                    @if (notify.notificationType === 'connection-rejected') {
                    <div class="tw-flex tw-items-center tw-gap-1 tw-mt-2">
                      <svg class="tw-w-4 tw-h-4 tw-text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                          d="M6 18L18 6M6 6l12 12" />
                      </svg>
                      <span class="tw-text-xs tw-text-red-600 tw-font-medium">Connection Declined</span>
                    </div>
                    }

                    @if (!isConnectionRequest(notify.notificationType) && (notify.postTitle || notify.commentContent ||
                    notify.followerText)) {
                    <div
                      class="tw-text-xs tw-font-medium tw-text-blue-600 dark:tw-text-blue-400 tw-flex tw-items-center tw-gap-1.5 tw-mt-1">
                      <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                      </svg>
                      <span class="tw-truncate tw-line-clamp-1 tw-text-ellipsis">
                        {{ notify.postTitle || notify.commentContent || notify.followerText }}
                      </span>
                    </div>
                    }
                  </div>
                </div>
              </div>
              } @empty {
              <!-- Empty State -->
              <div class="tw-p-6 tw-text-center">
                <div class="tw-inline-block tw-p-3 tw-rounded-full tw-bg-slate-100/50 dark:tw-bg-slate-700/50 tw-mb-3">
                  <svg class="tw-w-8 tw-h-8 tw-text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                  </svg>
                </div>
                <p class="tw-text-slate-500 dark:tw-text-slate-400 tw-m-0">All caught up! 🎉</p>
                <p class="tw-text-xs tw-text-slate-400 dark:tw-text-slate-500 tw-mt-1">No new notifications</p>
              </div>
              }

              <!-- Loading Indicator -->
              @if (isLoading) {
              <div class="tw-p-3 tw-text-center">
                <div
                  class="tw-inline-block tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-b-2 tw-border-gray-900 dark:tw-border-gray-100">
                </div>
                <p class="tw-text-xs tw-text-slate-500 tw-mt-2">Loading more notifications...</p>
              </div>
              }

              <!-- All Caught Up Indicator -->
              @if (!isLoading && notificationCount > 0 && notificationCount === notifications.length) {
              <div class="tw-p-3 tw-text-center tw-border-t tw-border-slate-100 dark:tw-border-slate-700/50">
                <div
                  class="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-text-slate-400 dark:tw-text-slate-500">
                  <svg class="tw-h-5 tw-w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13l4 4L19 7" />
                  </svg>
                  <span class="tw-text-sm tw-font-medium">You're all caught up</span>
                </div>
                <p class="tw-text-xs tw-text-slate-400 dark:tw-text-slate-500 tw-mt-1 tw-mb-0">
                  No more notifications to load
                </p>
              </div>
              }
            </div>

            <!-- Footer Actions -->
            @if (count > 0) {
            <div class="tw-sticky tw-bottom-0 tw-px-4 tw-py-3 tw-bg-white/50 dark:tw-bg-slate-800/50 
                          tw-border-t tw-border-slate-100/50 dark:tw-border-slate-700/50 tw-backdrop-blur-sm">
              <button (click)="markAllAsRead()" class="tw-w-full tw-py-2 tw-px-4 tw-rounded-lg tw-text-sm tw-font-semibold
                               tw-bg-slate-900/5 hover:tw-bg-slate-900/10 dark:tw-bg-white/5 dark:hover:tw-bg-white/10
                               tw-transition-colors tw-text-slate-700 dark:tw-text-slate-300 tw-border-0">
                <svg class="tw-w-4 tw-h-4 tw-inline tw-mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13l4 4L19 7" />
                </svg>
                Mark all as read
              </button>
            </div>
            }
          </div>
        </mat-menu>
      </li>


      <li class="nav-item dropdown no-arrow ml-1 osahan-profile-dropdown">
        @if (authService.user$ | async; as user) {
        <a class="nav-link dropdown-toggle pr-0" [matMenuTriggerFor]="profileMenu" role="button" aria-haspopup="true"
          aria-expanded="false" [matTooltip]="user.firstName+' '+user.lastName">
          @if (user.profilePictureKey.includes('Avatar')) {
          <app-user-avatar class="img-profile tw-rounded-full" [pictureKey]="user.profilePictureKey"
            [pictureTransform]="user.pictureTransform" [pictureID]="user.firstName">
          </app-user-avatar>
          } @else {
          <img class="img-profile tw-rounded-full" [src]="[profileApiUrl+user.profilePictureKey]"
            [alt]="user.firstName + ' profile_pic'" [style.transform]="'rotate(' + user.pictureTransform + 'deg)'">
          }
        </a>
        }
        <mat-menu #profileMenu="matMenu" xPosition="before" yPosition="below"
          class="tw-w-full tw-shadow-md m-0 dark:tw-bg-navy tw-bg-white tw-border dark:tw-border-navy tw-border-white border-0 tw-rounded-lg tw-px-2 tw-min-w-48 dark:tw-text-white tw-text-navy">

          <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white tw-text-navy"
            [href]="'/profile?user='+user.id">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <div class="tw-w-[23px]">
                <svg id="Capa_1" x="0px" y="0px" viewBox="0 0 512.004 512.004" xml:space="preserve">
                  <g>
                    <g>
                      <path
                        d="M314.35,408.004c-4.414,0-8-3.59-8-8s3.586-8,8-8c4.422,0,8-3.582,8-8s-3.578-8-8-8h-128 c-4.422,0-8,3.582-8,8s3.578,8,8,8c4.414,0,8,3.59,8,8s-3.586,8-8,8c-4.422,0-8,3.582-8,8s3.578,8,8,8h128c4.422,0,8-3.582,8-8 S318.772,408.004,314.35,408.004z"
                        style="fill: rgb(92, 84, 106);"></path>
                    </g>
                    <g>
                      <path
                        d="M413.374,196.004c0-2.395,0.93-4.641,2.625-6.336c7.539-7.535,7.539-19.793,0-27.328 l-95.141-95.144c6.055-9.934,14.086-31.086,0.859-62.312c-1.133-2.664-3.609-4.512-6.492-4.832 c-2.852-0.328-5.703,0.949-7.383,3.305c-11.539,16.148-34.695,30.871-61.508,47.918c-62.367,39.648-139.984,88.992-139.984,196.73 c0,90.687,48.359,130.07,63.187,139.984c3.937,2.625,8.539,4.016,13.312,4.016h138.633c8.32,0,15.93-4.215,20.352-11.281 l15.68-25.09c13.477-21.559,10.719-49.547-6.703-68.066l-84.453-89.723c8.672,1.238,19.359,2.16,31.992,2.16 c30.273,0,44.43,15.617,56.914,29.398c4.219,4.652,8.203,9.051,12.531,12.449c6.383,5.008,15.531,4.48,21.25-1.227l26.953-26.973 c3.125-3.125,3.125-8.191,0-11.316C414.304,200.645,413.374,198.398,413.374,196.004z"
                        style="fill: rgb(255, 210, 0);"></path>
                    </g>
                    <g>
                      <path
                        d="M186.351,216.004c0-124,109.277-123.334,127.984-215.933c-2.541,0.003-4.989,1.177-6.492,3.285 c-11.539,16.148-34.695,30.871-61.508,47.918c-62.367,39.648-139.984,88.992-139.984,196.73 c0,90.687,48.359,130.07,63.187,139.984c3.937,2.625,8.539,4.016,13.312,4.016h91.5 C274.35,296.671,186.351,298.393,186.351,216.004z"
                        style="fill: rgb(255, 150, 0);"></path>
                    </g>
                    <g>
                      <path
                        d="M401.718,445.062l-42.242-35.203c-1.438-1.199-3.25-1.855-5.125-1.855h-208 c-1.875,0-3.688,0.656-5.125,1.855l-42.234,35.199c-5.492,4.574-8.641,11.297-8.641,18.441v40.504c0,4.418,3.578,8,8,8h304 c4.422,0,8-3.582,8-8v-40.508C410.35,456.351,407.202,449.633,401.718,445.062z"
                        style="fill: rgb(185, 187, 193);"></path>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M266.35,128.004c-4.422,0-8-3.582-8-8c0-4.418,3.578-8,8-8c3.977,0,7.984-2.199,12.633-4.746 c9.133-5.012,21.648-11.859,39.195-2.277c3.883,2.117,5.312,6.977,3.195,10.855c-2.117,3.875-7,5.309-10.852,3.191 c-9.898-5.395-15.445-2.344-23.852,2.266C280.929,124.438,274.421,128.004,266.35,128.004z"
                          style="fill: rgb(255, 150, 0);"></path>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M298.35,128.004c-4.422,0-8-3.582-8-8v-8c0-4.418,3.578-8,8-8s8,3.582,8,8v8 C306.35,124.422,302.772,128.004,298.35,128.004z"
                          style="fill: rgb(255, 150, 0);"></path>
                      </g>
                    </g>
                    <g>
                      <path
                        d="M250.351,408.004h-104c-1.875,0-3.688,0.656-5.125,1.855l-42.234,35.199 c-5.492,4.574-8.641,11.297-8.641,18.441v40.504c0,4.418,3.578,8,8,8h152V408.004z"
                        style="fill: rgb(139, 137, 150);"></path>
                    </g>
                    <g>
                      <path
                        d="M90.351,463.5v40.504c0,4.418,3.578,8,8,8h304c4.422,0,8-3.582,8-8v-40.508 c0-2.598-0.549-5.09-1.342-7.492H91.694C90.899,458.408,90.351,460.901,90.351,463.5z"
                        style="fill: rgb(139, 137, 150);"></path>
                    </g>
                    <g>
                      <path
                        d="M250.351,456.004H91.694c-0.794,2.404-1.343,4.897-1.343,7.496v40.504c0,4.418,3.578,8,8,8h152 V456.004z"
                        style="fill: rgb(92, 84, 106);"></path>
                    </g>
                    <g>
                      <path
                        d="M266.358,197.844c1.546,0.221,3.233,0.416,4.907,0.613c-25.263-4.967-38.903-18.777-46.063-30.266 c-10.203-16.367-11.453-35.137-7.422-45.215c1.641-4.105-0.359-8.758-4.461-10.402c-4.07-1.633-8.758,0.355-10.398,4.457 c-6.648,16.637-3.156,40.594,8.703,59.621c14.352,23.023,39.25,36.988,70.125,39.328c0.203,0.016,0.406,0.023,0.609,0.023 c0.325,0,0.61-0.139,0.926-0.178L266.358,197.844z"
                        style="fill: rgb(255, 150, 0);"></path>
                    </g>
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </div>
            </div>
            My Profile
          </a>

          <!-- <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white tw-text-navy">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <div class="tw-w-[23px]">
                <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">
                  <path
                    d="M510.45,52.774L378.654,328.693H133.347L1.55,52.774C-3.421,42.36,4.169,30.332,15.696,30.332H158.58 c6.038,0,11.542,3.466,14.146,8.923L256,213.583l83.274-174.328c2.603-5.458,8.108-8.923,14.146-8.923h142.884 C507.831,30.332,515.421,42.36,510.45,52.774z"
                    style="fill: rgb(128, 208, 225);"></path>
                  <path
                    d="M378.654,328.693c-12.521-56.429-62.901-98.298-122.653-98.298 c-80.248,0-140.108,74.32-122.653,152.984c12.521,56.431,62.901,98.298,122.653,98.298 C336.248,481.676,396.108,407.357,378.654,328.693z M256,405.114v-0.016c-27.099,0-49.071-21.971-49.071-49.071 c0-27.099,21.971-49.071,49.071-49.071v0.016c27.099,0,49.071,21.971,49.071,49.071C305.071,383.143,283.1,405.114,256,405.114z"
                    style="fill: rgb(255, 199, 45);"></path>
                  <path
                    d="M256,481.676v-76.562c27.099,0,49.071-21.971,49.071-49.071c0-27.099-21.971-49.071-49.071-49.071 v-76.578c19.211,0,38.422,4.391,55.971,13.142c33.42,16.655,58.386,47.769,66.682,85.156 C396.108,407.357,336.248,481.676,256,481.676z"
                    style="fill: rgb(255, 190, 13);"></path>
                  <path
                    d="M256,306.979c-0.002,0-0.003,0-0.005,0c-27.085,0.003-49.06,21.956-49.06,49.064 c0,27.098,21.963,49.063,49.06,49.065c0.002,0,0.003,0,0.005,0c27.099,0,49.064-21.965,49.064-49.065 C305.065,328.937,283.093,306.979,256,306.979z"
                    style="fill: rgb(255, 228, 156);"></path>
                  <path
                    d="M256,306.979c-0.002,0-0.003,0-0.005,0v98.131c0.002,0,0.003,0,0.005,0 c27.099,0,49.064-21.965,49.064-49.065C305.065,328.937,283.093,306.979,256,306.979z"
                    style="fill: rgb(255, 199, 45);"></path>
                  <path
                    d="M353.425,30.324c-6.042,0-11.547,3.471-14.15,8.923L256,213.586l-0.005-0.011l-83.27-174.327 c-2.605-5.451-8.109-8.923-14.15-8.923H98.197l101.836,213.205c17.566-8.757,36.768-13.129,55.962-13.129 c19.214,0,38.421,4.38,55.973,13.129L413.804,30.324C413.804,30.324,353.425,30.324,353.425,30.324z"
                    style="fill: rgb(72, 174, 226);"></path>
                  <path
                    d="M510.448,52.766L378.655,328.69c-8.302-37.383-33.266-68.498-66.689-85.16L413.803,30.326h82.495 C507.832,30.324,515.421,42.357,510.448,52.766z"
                    style="fill: rgb(52, 148, 199);"></path>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </div>
            </div>
            Badges
          </a>

          <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white tw-text-navy">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <div class="tw-w-[23px]">
                <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 511.999 511.999" xml:space="preserve">
                  <path
                    d="M477.832,408.28H142.075c-7.691,0-13.929-6.236-13.929-13.929c0-7.693,6.237-13.929,13.929-13.929 h335.757c3.481,0,6.311-3.385,6.311-7.545V139.121c0-4.16-2.83-7.545-6.311-7.545H162.315c-3.481,0-6.311,3.385-6.311,7.545v167.826 c0,7.693-6.237,13.929-13.929,13.929c-7.691,0-13.929-6.236-13.929-13.929V139.121c0-19.521,15.328-35.402,34.168-35.402H477.83 c18.84,0,34.168,15.881,34.168,35.402v233.755C512,392.398,496.672,408.28,477.832,408.28z"
                    style="fill: rgb(255, 198, 27);"></path>
                  <path
                    d="M142.075,139.121L142.075,139.121c0,6.854,3.085,13.298,8.303,17.341l169.697,131.493 l169.697-131.493c5.218-4.043,8.303-10.485,8.303-17.341l0,0c0-11.86-9.062-21.474-20.24-21.474h-315.52 C151.137,117.648,142.075,127.262,142.075,139.121z"
                    style="fill: rgb(254, 225, 135);"></path>
                  <g>
                    <path
                      d="M320.073,301.884c-3.01,0-6.02-0.974-8.531-2.918L141.845,167.473 c-8.577-6.647-13.699-17.245-13.699-28.35c0-19.521,15.328-35.402,34.168-35.402H477.83c18.84,0,34.168,15.881,34.168,35.402 c0,11.105-5.122,21.704-13.7,28.35L328.604,298.966C326.093,300.912,323.083,301.884,320.073,301.884z M162.315,131.576 c-3.479,0-6.311,3.385-6.311,7.545c0,2.555,1.085,4.921,2.904,6.331l161.165,124.883l161.164-124.883 c1.819-1.41,2.905-3.776,2.905-6.331c0-4.16-2.832-7.545-6.311-7.545H162.315L162.315,131.576z"
                      style="fill: rgb(255, 198, 27);"></path>
                    <path
                      d="M140.681,195.17H13.929C6.237,195.17,0,188.934,0,181.242s6.237-13.929,13.929-13.929h126.752 c7.691,0,13.929,6.236,13.929,13.929S148.372,195.17,140.681,195.17z"
                      style="fill: rgb(255, 198, 27);"></path>
                    <path
                      d="M140.681,258.545H55.719c-7.691,0-13.929-6.236-13.929-13.929s6.237-13.929,13.929-13.929h84.962 c7.691,0,13.929,6.236,13.929,13.929S148.372,258.545,140.681,258.545z"
                      style="fill: rgb(255, 198, 27);"></path>
                    <path
                      d="M140.681,321.921H97.509c-7.691,0-13.929-6.236-13.929-13.929s6.237-13.929,13.929-13.929h43.172 c7.691,0,13.929,6.236,13.929,13.929S148.372,321.921,140.681,321.921z"
                      style="fill: rgb(255, 198, 27);"></path>
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </div>
            </div>
            Messages
          </a> -->

          <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white tw-text-navy"
            [href]="'/profile?user='+user.id+'&section=settings'">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <div class="tw-w-[23px]">
                <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">
                  <path
                    d="M256,123.586c-105.571,0-93.865,128.381-93.383,221.415c0.018,3.513,1.858,6.681,4.867,8.495 c11.699,7.052,43.826,23.54,88.515,23.54s76.817-16.488,88.515-23.54c3.009-1.814,4.85-4.982,4.867-8.495 C349.865,251.967,361.571,123.586,256,123.586z"
                    style="fill: rgb(105, 75, 75);"></path>
                  <path
                    d="M249.198,123.85c-98.185,5.504-87.052,130.186-86.581,221.15c0.019,3.513,1.858,6.681,4.868,8.495 c11.699,7.052,43.826,23.54,88.515,23.54l26.679-186.752"
                    style="fill: rgb(90, 65, 70);"></path>
                  <path
                    d="M256,123.586c-60.028,0-64.196,72.533-64.196,72.533c34.6-5.836,55.859,8.754,90.876-5.836 L256,377.036c44.689,0,76.817-16.488,88.515-23.54c3.009-1.814,4.85-4.982,4.868-8.495C349.865,251.968,361.571,123.586,256,123.586 z"
                    style="fill: rgb(105, 75, 75);"></path>
                  <path
                    d="M349.383,345.001c0.414-79.943,9.044-185.908-55.499-214.168c-1.125,5.848-3.165,22.175,2.134,32.771 c13.34,26.679,26.679,26.679,40.019,46.688c13.34,73.367-25.489,151.239-38.383,161.838l0,0 c22.848-5.434,39.227-14.033,46.861-18.635C347.524,351.682,349.364,348.514,349.383,345.001z"
                    style="fill: rgb(120, 85, 80);"></path>
                  <path
                    d="M357.073,365.236l-59.514-24.798c-4.971-2.071-8.209-6.929-8.209-12.313v-16.118h-66.697v16.118 c0,5.385-3.238,10.242-8.209,12.313l-59.514,24.798c-7.456,3.106-12.313,10.392-12.313,18.47v40.019 c0,7.367,5.972,13.34,13.34,13.34h200.092c7.367,0,13.34-5.972,13.34-13.34v-40.019 C369.385,375.628,364.529,368.342,357.073,365.236z"
                    style="fill: rgb(230, 175, 120);"></path>
                  <path
                    d="M357.073,365.236L299.53,341.26L256,360.045l-43.529-18.786l-57.543,23.976 c-7.456,3.106-12.313,10.392-12.313,18.47v40.02c0,7.367,5.972,13.34,13.34,13.34h200.092c7.367,0,13.34-5.972,13.34-13.34v-40.019 C369.385,375.628,364.529,368.342,357.073,365.236z"
                    style="fill: rgb(180, 225, 250);"></path>
                  <path
                    d="M289.348,312.006h-66.697v16.118c0,5.385-3.238,10.242-8.209,12.313l-9.295,3.873 C276.279,362.449,289.348,312.006,289.348,312.006z"
                    style="fill: rgb(210, 155, 110);"></path>
                  <g>
                    <path
                      d="M175.124,391.038l-26.772-21.294c-3.587,3.668-5.737,8.628-5.737,13.963v40.018 c0,7.367,5.972,13.34,13.34,13.34h26.679v-30.402C182.633,400.584,179.87,394.835,175.124,391.038z"
                      style="fill: rgb(160, 210, 240);"></path>
                    <path
                      d="M369.385,423.724v-40.019c0-5.293-2.114-10.22-5.651-13.88l-26.858,21.212 c-4.747,3.797-7.51,9.546-7.51,15.625v30.402h26.679C363.413,437.064,369.385,431.091,369.385,423.724z"
                      style="fill: rgb(160, 210, 240);"></path>
                    <path
                      d="M256,410.385L256,410.385c-3.683,0-6.669-2.986-6.669-6.669v-43.654h13.34v43.654 C262.669,407.399,259.683,410.385,256,410.385z"
                      style="fill: rgb(160, 210, 240);"></path>
                    <path
                      d="M256,360.046l-38.174-28.63c-2.451-1.838-5.942-1.24-7.641,1.309l-7.543,11.315l23.404,32.766 c1.779,2.49,5.284,2.977,7.676,1.065L256,360.046z"
                      style="fill: rgb(160, 210, 240);"></path>
                    <path
                      d="M256,360.046l38.174-28.63c2.451-1.838,5.942-1.24,7.641,1.309l7.543,11.315l-23.404,32.766 c-1.779,2.49-5.284,2.977-7.676,1.065L256,360.046z"
                      style="fill: rgb(160, 210, 240);"></path>
                  </g>
                  <path
                    d="M289.348,183.614c-33.348,33.348-98.795,6.669-98.795,60.028l4.141,39.305 c0.799,8.792,5.896,16.619,13.612,20.906l37.975,21.097c6.044,3.358,13.391,3.358,19.434,0l37.975-21.097 c7.716-4.287,12.813-12.115,13.612-20.906l4.781-46.68c0.34-3.318,0.413-6.656,0.3-9.985 C319.891,209.302,296.019,196.953,289.348,183.614z"
                    style="fill: rgb(240, 192, 135);"></path>
                  <path
                    d="M190.553,243.641l4.141,39.305c0.799,8.792,5.896,16.619,13.612,20.906l37.975,21.097 c4.193,2.329,9.002,2.933,13.58,2.029l0,0c0,0-19.147-5.802-30.541-36.649c-3.49-9.45-8.338-59.471-4.169-65.586 c8.239-12.085,54.191-13.34,67.769-35.758c-0.671-0.832-1.29-1.665-1.856-2.5c-0.046-0.067-0.102-0.135-0.146-0.202 c-0.589-0.887-1.124-1.775-1.571-2.669C256,216.962,190.553,190.283,190.553,243.641z"
                    style="fill: rgb(230, 175, 120);"></path>
                  <path
                    d="M307.2,410.385h-22.364c-4.875,0-8.828,3.953-8.828,8.828v17.852h40.019v-17.852 C316.028,414.337,312.075,410.385,307.2,410.385z"
                    style="fill: rgb(160, 210, 240);"></path>
                  <path
                    d="M509.323,219.339c-0.626-4.314-4.413-7.477-8.772-7.477h-19.318 c-5.959-30.578-17.953-58.996-34.746-83.928l13.632-13.632c3.085-3.085,3.521-8.014,0.907-11.508 c-14.708-19.652-32.168-37.112-51.821-51.821c-3.492-2.614-8.422-2.177-11.507,0.908l-13.633,13.633 c-24.93-16.794-53.348-28.788-83.926-34.746V11.449c0-4.36-3.162-8.147-7.477-8.772C280.686,0.94,268.456,0,256,0 s-24.686,0.94-36.661,2.677c-4.314,0.626-7.477,4.413-7.477,8.772v19.318c-30.578,5.959-58.996,17.952-83.927,34.746l-13.632-13.633 c-3.085-3.085-8.014-3.522-11.508-0.908c-19.652,14.709-37.112,32.169-51.821,51.821c-2.614,3.494-2.177,8.423,0.908,11.508 l13.633,13.633c-16.796,24.931-28.789,53.35-34.748,83.927H11.449c-4.36,0-8.147,3.162-8.772,7.477C0.941,231.314,0,243.544,0,256 s0.941,24.686,2.677,36.66c0.626,4.314,4.413,7.478,8.772,7.478h19.318c5.959,30.578,17.952,58.996,34.746,83.927l-13.633,13.633 c-3.085,3.085-3.522,8.014-0.908,11.508c14.709,19.652,32.168,37.112,51.821,51.82c3.494,2.614,8.422,2.177,11.508-0.908 l13.632-13.632c24.931,16.794,53.35,28.788,83.927,34.746v19.318c0,4.36,3.162,8.147,7.477,8.772 C231.314,511.059,243.544,512,256,512s24.686-0.941,36.661-2.677c4.315-0.626,7.477-4.413,7.477-8.772v-19.318 c30.578-5.959,58.996-17.952,83.927-34.746l13.633,13.632c3.085,3.085,8.014,3.522,11.507,0.908 c19.654-14.709,37.113-32.168,51.821-51.82c2.615-3.493,2.179-8.423-0.907-11.508l-13.632-13.632 c16.794-24.931,28.788-53.349,34.746-83.927h19.318c4.36,0,8.147-3.164,8.772-7.478C511.059,280.686,512,268.456,512,256 S511.059,231.314,509.323,219.339z M256,432.552c-97.507,0-176.552-79.046-176.552-176.552c0-97.507,79.044-176.552,176.552-176.552 S432.552,158.493,432.552,256C432.552,353.506,353.507,432.552,256,432.552z"
                    style="fill: rgb(199, 207, 226);"></path>
                  <path
                    d="M256,52.966C143.866,52.966,52.966,143.866,52.966,256c0,112.132,90.901,203.034,203.034,203.034 S459.034,368.132,459.034,256C459.034,143.866,368.134,52.966,256,52.966z M256,432.552c-97.507,0-176.552-79.046-176.552-176.552 c0-97.507,79.044-176.552,176.552-176.552S432.552,158.493,432.552,256C432.552,353.506,353.507,432.552,256,432.552z"
                    style="fill: rgb(175, 185, 210);"></path>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </div>
            </div>
            Settings
          </a>

          <a class="dropdown-item tw-text-sm hover:tw-text-white dark:tw-text-white tw-text-navy" (click)="logout()">
            <div
              class="mr-3 tw-h-8.5 tw-w-8.5 tw-rounded-full tw-bg-black/50 tw-flex tw-items-center tw-justify-center">
              <div class="tw-w-[23px]">
                <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 487.47 487.47" xml:space="preserve">
                  <g>
                    <path
                      d="M9.66,211.964c-12.88,12.89-12.88,33.85,0,46.74l93.6,93.6l46.74-46.74l-93.61-93.62 C43.5,199.074,22.55,199.084,9.66,211.964z"
                      style="fill: rgb(255, 205, 0);"></path>
                    <path
                      d="M35.58,130.254c-12.89,12.89-12.89,33.85,0,46.74l121.49,121.5c0.01,0,46.75-46.75,46.75-46.75 L82.31,130.234C69.42,117.364,48.47,117.374,35.58,130.254z"
                      style="fill: rgb(255, 205, 0);"></path>
                    <path
                      d="M63.92,50.954c-12.89,12.89-12.89,33.86,0,46.75l146.97,146.97l46.74-46.74L110.66,50.954 C97.78,38.074,76.81,38.074,63.92,50.954z"
                      style="fill: rgb(255, 205, 0);"></path>
                    <path
                      d="M311.45,144.114l69.19,69.19l53.81-53.81l17.55,17.54c22.87,22.88,35.47,53.3,35.47,85.65 c0,32.35-12.6,62.76-35.47,85.64l-90.72,90.72c-22.87,22.87-53.29,35.47-85.64,35.47c-32.35,0-62.77-12.6-85.64-35.47l-86.74-86.74 L311.45,144.114z"
                      style="fill: rgb(255, 218, 68);"></path>
                    <path
                      d="M143.21,22.624c-6.24,6.24-9.68,14.54-9.68,23.37s3.44,17.13,9.68,23.37l121.49,121.5l46.75-46.75 L189.96,22.624C177.07,9.734,156.1,9.734,143.21,22.624z"
                      style="fill: rgb(255, 205, 0);"></path>
                    <path
                      d="M326.21,97.994c-12.89,12.88-12.89,33.85,0,46.74l61.5,61.5l46.74-46.74l-61.5-61.5 c-6.24-6.25-14.54-9.68-23.37-9.68C340.75,88.314,332.45,91.744,326.21,97.994z"
                      style="fill: rgb(255, 205, 0);"></path>
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </div>
            </div>
            Logout
          </a>

        </mat-menu>
      </li>

      <li class="nav-item tw-ml-2 tw-cursor-pointer sm:tw-block tw-hidden" matTooltip="User Influence" matTooltipPosition="below">
        <div class="tw-flex tw-flex-row tw-items-center nav-link">
          <div class="tw-w-5">
            <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 495 495" xml:space="preserve">
              <g>
                <path
                  d="M358.55,3.91c-45.78,0-86.3,22.55-111.05,57.16v430.02l216.71-264.4 c19.25-23.52,30.79-53.58,30.79-86.34C495,65,433.91,3.91,358.55,3.91z"
                  style="fill: rgb(228, 24, 122);"></path>
                <path
                  d="M136.45,3.91C61.09,3.91,0,65,0,140.35c0,32.76,11.54,62.82,30.79,86.34l216.71,264.4V61.07 C222.75,26.46,182.23,3.91,136.45,3.91z"
                  style="fill: rgb(237, 83, 157);"></path>
              </g>
            </svg>
          </div>
          <div class="tw-text-white/80 tw-ml-2 tw-font-bold tw-text-sm">
            @if (authService.user$ | async; as user) {
            {{user.influence}}
            }
          </div>
        </div>
      </li>

      } @else {
      <li class="nav-item" matTooltip="Log in" matTooltipPosition="below">
        <a class="nav-link lg:tw-rounded-full lg:tw-border lg:tw-border-white/60 lg:hover:tw-border-white lg:hover:tw-bg-white/10 lg:tw-px-4 lg:tw-mx-1 tw-transition-colors" (click)="openLoginDialog()">
          <ng-icon name="heroLockOpen" size="18" class="icon-style lg:tw-hidden" />
          <span class="tw-hidden lg:tw-inline tw-font-semibold">Log In</span>
        </a>
      </li>

      <li class="nav-item" matTooltip="Join free" matTooltipPosition="below">
        <a class="nav-link lg:tw-rounded-full lg:tw-bg-orange-500 lg:hover:tw-bg-orange-600 lg:tw-text-white lg:hover:tw-text-white lg:tw-px-4 lg:tw-mx-1 tw-transition-colors" (click)="openSignupDialog()">
          <svg class="icon-style lg:tw-hidden" height="20" viewBox="0 -960 960 960" width="20" fill="currentColor">
            <path
              d="M226-160q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm0-254q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm0-254q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 254q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47l-66 66Zm0-254q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm-40 508v-65l243-243 65 65-243 243h-65Zm294-508q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm40 239-65-65 25-25q8-8 20-8.5t20 7.5l26 26q8 8 7.5 20t-8.5 20l-25 25Z">
            </path>
          </svg>
          <span class="tw-hidden lg:tw-inline tw-font-semibold">Join Free</span>
        </a>
      </li>
      }

      <!-- Light/dark toggle moved to the site footer (Sep 16) -->
    </ul>
  </div>
</nav>